import React from 'react';
import remoteFiles from '../../../../../common/remote_files';
import { claimNumbers } from '../../express_numbers';

const ReadMoreClaim = ({ onGetStarted }) => {
  const {
    conceptFocus, testedClaims, thoughtBubble
  } = remoteFiles.express.steps.claim;
  const {
    step12x, step62x, step72x, screenerQuestion
  } = remoteFiles.express.steps.base;
  return (
    <>
      <div className="modal_body">
        <div className="express-steps">
          <h3 className="express-steps_title">Claims</h3>
          <h2 className="express-steps_subtitle">Here’s how it works</h2>
          <div className="express-steps_list">
            <div className="express-steps_item">
              <div className="express-steps_col">
                <div className="express-steps_item-text">Select your audience</div>
              </div>
              <div className="express-steps_col">
                <div className="express-steps_item-img">
                  <img src={ step12x } />
                </div>
              </div>
            </div>
            <div className="express-steps_item">
              <div className="express-steps_col">
                <div className="express-steps_item-text">
                  <p>Create up to 3 screener questions</p>
                  <p className="-descr">Adding screener questions may impact cost and timing.</p>
                </div>
              </div>
              <div className="express-steps_col">
                <div className="express-steps_item-img">
                  <img src={ screenerQuestion } />
                </div>
              </div>
            </div>
            <div className="express-steps_item -no-bottom-line">
              <div className="express-steps_col">
                <div className="express-steps_item-text">
                  <p>Input your claims</p>
                  <p className="-descr">
                    You can enter up to { claimNumbers.claimsMax.express } claims
                    {''}
                    or upload an Excel file.
                  </p>
                </div>
              </div>
              <div className="express-steps_col">
                <div className="express-steps_item-img">
                  <img src={ testedClaims } />
                </div>
              </div>
            </div>
            <div className="express-steps_item -no-flex -no-bottom-line">
              <div className="express-steps_header-wrapper">
                <h3 className="express-steps_item-header">Methodologies</h3>
              </div>
              <div className="express-steps_inner-col">
                <div className="express-steps_item-text">
                  <p>MaxDiff</p>
                  <p className="-descr">
                    MaxDiff is an advanced analytics technique designed to obtain
                    { ' ' }
                    preference/importance scores (utilities) for multiple options of a single item
                    { ' ' }
                    (such as product features, claims, etc.) Respondents are shown a subset of
                    { ' ' }
                    the options, and are then asked to indicate which one is the "best" and which
                    { ' ' }
                    is "worst". MaxDiff uses the respondent's choices to estimate scores for each
                    { ' ' }
                    of the claims.
                  </p>
                </div>
              </div>
              <div className="express-steps_inner-col">
                <div className="express-steps_item-text">
                  <p>MaxDiff (TURF)</p>
                  <p className="-descr">
                    TURF analysis is used to determine the best combinations of a given number of
                    { ' ' }
                    items by maximizing unduplicated reach. If included, respondents will evaluate
                    { ' ' }
                    all items (max { claimNumbers.claimsMax.express }) and TURF analysis is an option
                    {' '}
                    for reporting. Ideal for {claimNumbers.claimsMin.express}-{ claimNumbers.claimsMax.express }
                    { ' ' }
                    items.
                  </p>
                </div>
              </div>
            </div>
            <div className="express-steps_item -no-flex">
              <div className="express-steps_header-wrapper">
                <h3 className="express-steps_item-header">Respondent Experience</h3>
              </div>
              <div className="express-steps_inner-col">
                <div className="express-steps_col">
                  <div className="express-steps_item-text">
                    <p>Thought Bubble</p>
                    <p className="-descr">
                      For 2 of the claims, randomly selected, respondents will participate in this
                      { ' ' }
                      projective technique for unaided associations.
                    </p>
                  </div>
                </div>
                <div className="express-steps_col">
                  <div className="express-steps_item-img">
                    <img src={ thoughtBubble } />
                  </div>
                </div>
              </div>
              <div className="express-steps_inner-col">
                <div className="express-steps_col">
                  <div className="express-steps_item-text">
                    <p>Concept Focus</p>
                    <p className="-descr">
                      With Concept Focus respondents will mark up what they like and dislike for 2
                      claims, randomly selected.
                    </p>
                  </div>
                </div>
                <div className="express-steps_col">
                  <div className="express-steps_item-img">
                    <img src={ conceptFocus } />
                  </div>
                </div>
              </div>
            </div>
            <div className="express-steps_item">
              <div className="express-steps_col">
                <div className="express-steps_item-text">Enter your credit card</div>
              </div>
              <div className="express-steps_col">
                <div className="express-steps_item-img">
                  <img src={ step62x } />
                </div>
              </div>
            </div>
            <div className="express-steps_item">
              <div className="express-steps_col">
                <div className="express-steps_item-text">And Launch!</div>
              </div>
              <div className="express-steps_col">
                <div className="express-steps_item-img">
                  <img src={ step72x } />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal_footer -bg-gray -center">
        <div className="modal_footer-button">
          <button className="button modal_button" onClick={ onGetStarted }>
            Get Started
          </button>
        </div>
      </div>
    </>
  );
};

export default ReadMoreClaim;
